import { render, staticRenderFns } from "./fk-map.vue?vue&type=template&id=231b5410&scoped=true&"
import script from "./fk-map.vue?vue&type=script&lang=js&"
export * from "./fk-map.vue?vue&type=script&lang=js&"
import style0 from "./fk-map.vue?vue&type=style&index=0&id=231b5410&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b5410",
  null
  
)

export default component.exports